import { GtmEvent, GtmPage } from 'src/app/interfaces/gtm.interface';
import { Category, EventType, LabelsEvents, Page, PathPages, Subcategories } from './gtm-utils';

export const PageEventTags: { [key: string]: GtmPage } = {
	companyData: {
		page: `${Page}${PathPages.companyData}`,
		pagename: `${Category} - ${Subcategories.companyData}`,
	},
	dataValidation: {
		page: `${Page}${PathPages.dataValidation}`,
		pagename: `${Category} - ${Subcategories.dataValidation}`,
	},
	bciClientError: {
		page: `${Page}${PathPages.error}/${PathPages.bciClientError}`,
		pagename: `${Category} - ${Subcategories.error} - ${Subcategories.bciClient}`,
	},
	genericError: {
		page: `${Page}${PathPages.error}/${PathPages.genericProblem}`,
		pagename: `${Category} - ${Subcategories.error} - ${Subcategories.genericProblem}`,
	},
	verificationError: {
		page: `${Page}${PathPages.error}/${PathPages.VerificationProblem}`,
		pagename: `${Category} - ${Subcategories.error} - ${Subcategories.VerificationProblem}`,
	},
	leakModal: {
		page: `${Page}${PathPages.leak}`,
		pagename: `${Category} - ${Subcategories.leakModal}`,
	},
};

export const ClickEventTags: { [key: string]: GtmEvent } = {
	validateData: {
		category: `${Category} - ${Subcategories.companyData}`,
		action: EventType.click,
		label: LabelsEvents.continue,
	},
	verifyOtp: {
		category: `${Category} - ${Subcategories.dataValidation}`,
		action: EventType.click,
		label: LabelsEvents.continue,
	},
	resendCode: {
		category: `${Category} - ${Subcategories.dataValidation}`,
		action: EventType.click,
		label: LabelsEvents.resendCode,
	},
	editPhone: {
		category: `${Category} - ${Subcategories.dataValidation}`,
		action: EventType.click,
		label: LabelsEvents.editPhone,
	},
	updatePhone: {
		category: `${Category} - ${Subcategories.dataValidation}`,
		action: `${EventType.modal} - ${EventType.click}`,
		label: LabelsEvents.update,
	},
	bciClientError: {
		category: `${Category} - ${Subcategories.error} - ${Subcategories.bciClient}`,
		action: EventType.click,
		label: LabelsEvents.understood,
	},
	genericError: {
		category: `${Category} - ${Subcategories.error} - ${Subcategories.genericProblem}`,
		action: EventType.click,
		label: LabelsEvents.understood,
	},
	verificationError: {
		category: `${Category} - ${Subcategories.error} - ${Subcategories.VerificationProblem}`,
		action: EventType.click,
		label: LabelsEvents.goHome,
	},
	leakGoOut: {
		category: `${Category} - ${Subcategories.leakModal}`,
		action: EventType.click,
		label: LabelsEvents.goOut,
	},
	leakContinue: {
		category: `${Category} - ${Subcategories.leakModal}`,
		action: EventType.click,
		label: `${LabelsEvents.continue} ${LabelsEvents.simulation}`,
	},
	whatsappContact: {
		category: `${Category}`,
		action: EventType.click,
		label: `${LabelsEvents.contact}`,
	},
};

export const ModalEventTags: { [key: string]: GtmEvent } = {
	editPhone: {
		category: `${Category} - ${Subcategories.dataValidation}`,
		action: EventType.modal,
		label: LabelsEvents.editPhone,
	},
};

export const SnackbarEventTags: { [key: string]: GtmEvent } = {
	incorrectCode: {
		category: `${Category} - ${Subcategories.message} - ${Subcategories.dataValidation} - ${Subcategories.incorrectCode}`,
		action: EventType.snackbar,
		label: LabelsEvents.incorrectCode,
	},
	expiredCode: {
		category: `${Category} - ${Subcategories.message} - ${Subcategories.dataValidation} - ${Subcategories.expiredCode}`,
		action: EventType.snackbar,
		label: LabelsEvents.expiredCode,
	},
	resendCode: {
		category: `${Category} - ${Subcategories.message} - ${Subcategories.dataValidation} - ${Subcategories.resendCode}`,
		action: EventType.snackbar,
		label: LabelsEvents.forwardedCode,
	},
};
